var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShareFacebook = function SvgShareFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 22,
    viewBox: "0 0 13 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3B5997",
    fillRule: "nonzero",
    d: "M12.204 6.843H8.292V5.097c0-.822.544-1.013.927-1.013h2.74V.47L7.99.458c-3.6 0-4.282 2.694-4.282 4.419v1.965H.958v3.667h2.75v11h4.584v-11h3.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 0h22v22H-5z"
  }))));
};
export default SvgShareFacebook;